import { render, staticRenderFns } from "./IconFont.vue?vue&type=template&id=7b157a88&scoped=true&"
import script from "./IconFont.vue?vue&type=script&lang=ts&"
export * from "./IconFont.vue?vue&type=script&lang=ts&"
import style0 from "./IconFont.vue?vue&type=style&index=0&id=7b157a88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b157a88",
  null
  
)

export default component.exports